// BADGE IMAGE

// BADGE

// OTHER

// TYPE CHECKS

export function isBadgeImageSelected(item) {
  return item.imageId !== null;
}